import { dashboardData, getDashboardWidgetData } from './DashboardMockData';
import { getResponse } from './helpers';

export const DASHBOARD_LAYOUT_ID = 'iterableDashboardLayout';
export const DASHBOARD_DATA_ID = 'iterableDashboardData';

/**
 * getDashboardData
 * Get dashboard data from local localStorage.
 * @param { String } id: id of the localStorage object,
 * @param { Object } props: helper props to retrieve data from localStorage.
 * @returns { Object } The parse json dashboard data.
 */
export const getDashboardData = (id, props) => {
  const getTestData = () => (id === DASHBOARD_LAYOUT_ID ? dashboardData : {});
  if (window.localStorage) {
    if (id === DASHBOARD_LAYOUT_ID) {
      return JSON.parse(window.localStorage.getItem(id)) || getTestData();
    }
    return getDashboardWidgetData(props);
  }
  return getTestData();
};

/**
 * setDashboardData
 * Saves dashboard data to localStorage.
 * @param { Object } data: The data to save to localStorage.
 * @return { void }
 */
export const setDashboardData = (data) => {
  if (window.localStorage && !data.type) {
    window.localStorage.setItem(DASHBOARD_LAYOUT_ID, JSON.stringify(data));
  }
};

/**
 * clearDashboardData
 * Clear and reset dashboard data in localStorage.
 * @returns { String } success message
 */
export const clearDashboardData = () => {
  if (window.localStorage) {
    window.localStorage.removeItem(DASHBOARD_LAYOUT_ID);
    window.localStorage.removeItem(DASHBOARD_DATA_ID);
    return 'Dashboard Data Cleared. Refresh to get new dashboard.';
  }
  return '';
};
window.clearDashboardData = clearDashboardData;

/**
 * fetchMockDashboard
 * Fetches dashboard data containing widgets and settings.
 * @returns { Promise } Fetched dashboard data.
 */
export const fetchMockDashboard = () => getResponse(getDashboardData(DASHBOARD_LAYOUT_ID));

/**
 * fetchMockDashboardData
 * Fetches data for a particular dashboard widget.
 * @param { Object } props: Props for fetching widget data {
 *     @param { Object } metric: The metric of the widget.
 *     @param { String } dataType: The type of data to fetch for. (e.g. 'series', 'sum').
 *     @param { String } startRange: The start range date/time to fetch data for.
 *     @param { String } endRange: The end range date/time to fetch data for.
 * }
 * @returns { Promise } Fetched dashboard widget data.
 */
export const fetchMockDashboardData = (props) =>
  getResponse(getDashboardData(DASHBOARD_DATA_ID, props));

/**
 * saveMockDashboard
 * Saves dashboard data.
 * @param { Object } data: Dashboard widgtes and settings to save.
 * @returns { Promise } Reponse status of save.
 */
export const saveMockDashboard = (data) => {
  setDashboardData(data);
  return getResponse({
    status: 200,
    message: 'Dashboard Saved',
  });
};
